import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import {
  DealsPage,
  areDealsSearchEqual,
  dealsLoaderDeps,
  dealsQueryOptions,
  dealsSearchSchema,
  normalizeDealsSearch,
} from '@/features/deals';

export const Route = createFileRoute('/_authed/deals/')({
  validateSearch: zodValidator(dealsSearchSchema),
  loaderDeps: ({ search }) => dealsLoaderDeps(search),
  loader: ({ cause, context, deps }) => {
    if (cause !== 'enter') return;
    void context.queryClient.prefetchQuery(dealsQueryOptions(deps));
  },
  beforeLoad: ({ search }) => {
    const normalizedSearch = normalizeDealsSearch(search);

    if (!areDealsSearchEqual(search, normalizedSearch)) {
      throw redirect({
        to: '/deals',
        search: normalizedSearch,
        replace: true,
      });
    }
  },
  component: () => <DealsPage />,
});
